import { Button } from '@material-ui/core';
import en from '../../lang/en-us';
import { SubmitButton } from '../../lib/Button';
import Image from '../Image';
const { dashboard } = en;

type NoFoliosFoundPropsType = {
    info?: string;
    extraClass?: string;
    icon?: string;
    onClick?: null | (() => void);
};

export default function NoFoliosFound({
    info = '',
    extraClass = '',
    icon = 'folios-not-found',
    onClick = null,
}: NoFoliosFoundPropsType) {
    return (
        <div className={`folios-not-found ${extraClass}`}>
            <Image src={`/images/${icon}.svg`} alt="icon" />
            {/* <p>{info}</p> */}
            <p>{info || dashboard.noFoliosFound}</p>
            {!!onClick &&
                <SubmitButton
                    label="Go to e-Mandate"
                    onClick={onClick}
                    style={{
                        width: "50%",
                        fontSize: "12px",
                        padding: '10px',
                        marginTop: '15px',
                        marginLeft: '25%',
                    }}
                />
            }
        </div>
    );
}
